module.exports = __webpack_public_path__ + "img/info-icon.d5f974fb.svg";